module.exports = __webpack_public_path__ + "static/media/charger-pin-high-power-selected.e0bd2c09.svg";